import { render, staticRenderFns } from "./RecuperarContrasena.vue?vue&type=template&id=5f949d83&scoped=true"
import script from "./RecuperarContrasena.vue?vue&type=script&lang=js"
export * from "./RecuperarContrasena.vue?vue&type=script&lang=js"
import style0 from "./RecuperarContrasena.vue?vue&type=style&index=0&id=5f949d83&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f949d83",
  null
  
)

export default component.exports